import { render, staticRenderFns } from "./AnaIVA.vue?vue&type=template&id=65fb6c15&scoped=true&"
import script from "./AnaIVA.vue?vue&type=script&lang=js&"
export * from "./AnaIVA.vue?vue&type=script&lang=js&"
import style0 from "./AnaIVA.vue?vue&type=style&index=0&id=65fb6c15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fb6c15",
  null
  
)

export default component.exports